import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '@/views/HomeView';

Vue.use(VueRouter);

const routes = [
  {
    path: '/auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/layouts/TheAuthLayout'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/pages/login'),
      },
      // {
      //   path: 'forgot',
      //   name: 'forgot',
      //   component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/pages/forgot'),
      // },
      // {
      //   path: 'asan',
      //   name: 'asan',
      //   component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/pages/asan'),
      // },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/pages/register'),
      },
      // {
      //   path: 'register/otp',
      //   name: 'otp',
      //   component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/pages/register'),
      // },
    ],
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/layouts/TheAppLayout'),
    children: [
      {
        path: '',
        name: 'dashboard-root',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/root'),
      },
      {
        path: 'mno',
        name: 'mno-category',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/mno-static-payment/category'),
      },
      {
        path: 'mno/payment',
        name: 'mno-product',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/mno-static-payment/product-v3'),
      },
      {
        path: 'c/:id',
        name: 'category-page',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/category'),
      },
      {
        path: 'c/:cid/p/:pid',
        name: 'product-page',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/product'),
      },
      {
        path: 'v3/c/:cid/p/:pid',
        name: 'v3-product-page',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/product-v3'),
      },
      {
        path: 'payment/receipt/:id',
        name: 'payment-receipt',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/product/receipt'),
      },
      {
        path: 'favorites',
        name: 'favorites',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/favorites'),
      },
      {
        path: 'favorites/receipt',
        name: 'favorites-receipt',
        component: () => import('@/views/dashboard/pages/favorites/payAllDebts/receipt'),
      },
      {
        path: 'create-favorite',
        name: 'create-favorite',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/favorites/create-favorite'),
      },
      {
        path: 'create-favorite/c/:id',
        name: 'create-favorite-category',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/favorites/create-favorite/payment-steps/category'),
      },
      {
        path: 'create-favorite/c/:cid/p/:pid',
        name: 'create-favorite-product',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/favorites/create-favorite/payment-steps/product'),
      },
      {
        path: 'v3/create-favorite/c/:cid/p/:pid',
        name: 'v3-create-favorite-product',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/favorites/create-favorite/payment-steps/product-v3'),
      },
      {
        path: 'autopayment',
        name: 'autopayment',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/autopayment'),
      },
      {
        path: 'create-autopayment',
        name: 'create-autopayment',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/autopayment/create-autopayment'),
      },
      {
        path: 'create-autopayment/c/:id',
        name: 'create-autopayment-category',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/autopayment/create-autopayment/autopay-steps/category'),
      },
      {
        path: 'v3/create-autopayment/c/:cid/p/:pid',
        name: 'v3-create-autopayment-product',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/autopayment/create-autopayment/autopay-steps/product-v3'),
      },
      {
        path: 'create-autopayment/c/:cid/p/:pid',
        name: 'create-autopayment-product',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/autopayment/create-autopayment/autopay-steps/product'),
      },
      {
        path: 'cards',
        name: 'cards',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/cards'),
      },
      {
        path: 'cards',
        name: 'cobrand-info',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/cards/cobrand/info'),
      },
      {
        path: 'cards/cobrand-order',
        name: 'cobrand-order',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/cards/cobrand/order'),
      },
      {
        path: 'cards/cobrand-topup',
        name: 'cobrand-topup',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/cards/cobrand/topup'),
      },
      {
        path: 'cards/cobrand-transfers',
        name: 'cobrand-transfers',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/transfers'),
      },
      {
        path: 'payments',
        name: 'payments',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/payments'),
      },
      {
        path: 'top-up',
        name: 'top-up',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/top-up'),
      },
      {
        path: 'top-up/receipt/:id',
        name: 'top-up-receipt',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/top-up/receipt'),
      },
      {
        path: 'terminal/receipt/:id',
        name: 'terminal-receipt',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/transactions/terminal-receipt'),
      },
      {
        path: 'transfer',
        name: 'transfer',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/transfer'),
      },
      {
        path: 'transfer/receipt/:id',
        name: 'transfer-receipt',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/transfer/receipt'),
      },
      {
        path: 'transfers',
        name: 'transfers',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/transfers'),
      },
      {
        path: 'coupons',
        name: 'coupons',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/coupons'),
      },
      {
        path: 'coupon/receipt/:id',
        name: 'coupon-receipt',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/coupons/receipt'),
      },
      {
        path: 'transactions',
        name: 'transactions',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/pages/transactions'),
      },
      {
        path: 'automobiles',
        name: 'automobiles',
        component: () => import('@/views/dashboard/pages/automobiles'),
      },
      {
        path: 'automobiles/transactions',
        name: 'automobiles-transactions',
        component: () => import('@/views/dashboard/pages/transactions'),
      },
      {
        path: 't/:id',
        redirect: (to) => {
          return {
            path: 'payment/receipt/:id', params: { id: to.params.id },
          };
        },
      },
    ],
  },
  {
    path: '/sima-verification',
    name: 'sima-verification',
    component: () => import('@/views/sima-verification/SimaVerification'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/layouts/TheSettingsLayout'),
    children: [
      {
        path: 'personal',
        name: 'personal',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/pages/personal'),
      },
      {
        path: 'password',
        name: 'password',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/pages/password'),
      },
      {
        path: 'language',
        name: 'language',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/pages/language'),
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/pages/notifications'),
      },
      {
        path: 'terms-conditions',
        name: 'terms-conditions',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/pages/termsConditions'),
      },
    ],
  },
  // {
  //   path: '/500',
  //   name: 'server-error',
  //   component: () => import('@/views/error/pages/server-error'),
  // },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('@/views/invite-friend'),
  },
  {
    path: '/mpay-link',
    name: 'mpay-link',
    component: () => import('@/views/qr-scanner/auth'),
  },
  {
    path: '/under-development',
    name: 'under-development',
    component: () => import('@/views/under-development'),
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/*',
    name: 'not-found',
    component: () => import('@/views/error/pages/not-found'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

function hasActiveToken() {
  return Vue.$cookies.get('token');
}

const entrances = [
  '/auth/login',
  '/auth/register',
  // '/auth/register/otp',
  '/auth/forgot',
  '/sima-verification',
  '/invite',
  '/mpay-link',
];

router.beforeEach(async (to, from, next) => {
  const isUnderMaintenance = JSON.parse(localStorage.getItem('isUnderMaintenance'));
  const url = new URL(window.location);
  const urlToken = url.searchParams.get('token');
  if (urlToken) {
    Vue.$cookies.set('token', atob(urlToken));
    const newUrl = url.origin + url.pathname;
    window.location.href = newUrl;
  }

  if (!isUnderMaintenance) {
    if (hasActiveToken()) {
      if (entrances.includes(to.path) && to.path !== '/sima-verification' && to.path !== '/invite' && to.path !== '/mpay-link') {
        next('/');
      } else if (to.path === '/') {
        next(to.meta.redirect);
      } else if (to.meta && !to.meta.disabled && to.meta.redirect) {
        next(to.meta.redirect);
      } else {
        next();
      }
    } else if (!entrances.includes(to.path)) {
      next('/auth/login');

      // const queryString = window.location.search;
      // const urlParams = new URLSearchParams(queryString);
      // const isAds = urlParams.get('isAds');
      // // console.log();
      // const pathNamesList = window.location.pathname.split('/');
      // if (isAds) {
      //   const userAgent = navigator.userAgent || window.opera;
      //   if (/Mobile/i.test(userAgent)) {
      //     window.location.href = `mpay://payments?category=${pathNamesList[2]}&provider=${pathNamesList[4]}&categoryName`;
      //     setTimeout(() => {
      //       window.location.href = 'https://onelink.to/mpay.yukle';
      //     }, 2000);
      //   } else {
      //     store.dispatch('user/setAdsModalStatus', true);
      //   }
      // }
    } else {
      next();
    }
  } else if (to.path !== '/under-development') {
    next('/under-development');
  } else {
    next();
  }
});

export default router;
